import componentRegistry from '../registry.js';
import { isMobile } from '../../configuration/Configuration.js';
import './seller-tabs.less';
import '../scroll-to/index.js';

const CLASSNAMES = {
  TABS_LINK: 'js-tabsLink',
  TAB_LINK: 'js-tabLink',
  TABS_CONTENT: 'js-tabsContent',
  TABS_LINK_CONTENT: 'js-tabsLinkContent',
  HEADER_NAV: 'js-header-nav',
  TAB_LIST: 'js-tabList',
};

export default class SellerTabs {
  #tabs;
  #tabsLink;
  #tabsList;
  #tabsLinkcontent;

  constructor({ el }) {
    this.el = el;
    this.#tabsLink = el.querySelectorAll('.' + CLASSNAMES.TABS_LINK);
    this.#tabsLink.forEach((item) => item.addEventListener('click', this._handleClick.bind(this)));
    this.#tabsLinkcontent = document.querySelectorAll('.' + CLASSNAMES.TABS_LINK_CONTENT);
    this.#tabsLinkcontent.forEach((item) => item.addEventListener('click', this._handleClick.bind(this)));
    this.#tabs = el.querySelectorAll('.' + CLASSNAMES.TABS_CONTENT);
    this.#tabsList = el.querySelector('.' + CLASSNAMES.TAB_LIST);
  }

  _handleClick(e) {
    e.preventDefault();
    var tabActive = document.querySelector(e.target.getAttribute('href'));

    if (e.target.classList.contains(CLASSNAMES.TABS_LINK_CONTENT)) {
      this.#tabsLink.forEach((item) => {
        if (e.target.getAttribute('href') == item.firstElementChild.getAttribute('href')) {
          this._activeTabs(tabActive, item.firstElementChild);
        }
      });
    } else {
      this._activeTabs(tabActive, e.target);
    }
    this._scrollTo(e, tabActive);
  }

  _scrollTo(e, tabActive) {
    var positionTabs = document.querySelector('.' + CLASSNAMES.TABS_LINK);
    var scrollTop = positionTabs.offsetTop - document.querySelector('.' + CLASSNAMES.HEADER_NAV)?.offsetHeight;

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  }

  _activeTabs(tabActive, linkActive) {
    this.#tabs.forEach((item) => {
      item.classList.remove('isActive');
      item.setAttribute('aria-expanded', false);
    });

    tabActive.classList.add('isActive');
    tabActive.setAttribute('aria-expanded', true);

    this.#tabsLink.forEach((item) => {
      item.classList.remove('isActive');
    });

    linkActive.parentNode.classList.add('isActive');

    if (isMobile) {
      this.#tabsList.scrollLeft = linkActive.offsetLeft > 30 ? linkActive.offsetLeft - 30 : linkActive.offsetLeft;
    }
  }
}

componentRegistry.define('js-sellerTabs', SellerTabs);
